// extracted by mini-css-extract-plugin
export default {"products":"oA-z","card":"pA-z","oosMessaging":"qA-z"};